import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';

import { AimoServiceNotificationComponent } from './aimo-service-notification.component';
import { AimoTopHeaderComponent } from './aimo-top-header.component';
import {AimoPipesModule} from "../../shared/utils/safe-html/aimo-pipes.module";

@NgModule({
    imports: [
        I18nModule,
        CommonModule,
        RouterModule,
        NgbPopoverModule,
        ConfigModule.withConfig(<CmsConfig>{
            cmsComponents: {
                TopHeaderComponent: {
                    component: AimoTopHeaderComponent,
                },
                AimoServiceNotificationComponent: {
                    component: AimoServiceNotificationComponent,
                },
            },
        }),
        AimoPipesModule,
    ],
    declarations: [AimoTopHeaderComponent, AimoServiceNotificationComponent],
    exports: [AimoTopHeaderComponent, AimoServiceNotificationComponent],
})
export class AimoTopHeaderModule {}
